import { useEffect, useRef, useState } from "react";
import LoginTemplate from "../LoginTemplate.js";
import { useSearchParams } from "react-router-dom";
import {
  actions as loginActions,
  asyncActions as loginAsyncActions,
} from "../../../store/slices/loginSlice.js";
import { useDispatch, useSelector } from "react-redux";

import { asyncActions as successAsyncActions } from "../../../store/slices/successSlice.js";

import { useNavigate } from "react-router-dom";

const EmailVerificationView = ({
  title,
  autoRelogin = false,
  afterLoginRoutesPath = [],
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const requestSent = useRef(false);

  const loginState = useSelector((state) => state.loginState);

  const [verificationMessage, setVerificationMessage] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const token = searchParams.get("token");
  const cid = searchParams.get("cid");
  const he = searchParams.get("he");

  useEffect(() => {
    
    let resPromise;
    if (requestSent.current === false) {
      const reza = (resPromise = dispatch(
        loginAsyncActions.verifyMailToken({
          token: token,
          cid: cid,
          he: he,
          navigate: navigate,
          setErrorMsg: setVerificationMessage,
        })
      ));
      reza.then((res) => {
        console.log(res);
      });
      requestSent.current = true;
    }

    return () => {
      // if (resPromise) {
      //   resPromise.abort();
      // } ne abortaj!! double request
    };
  }, []);

  return (
    <>
      <LoginTemplate
        heading={title}
        error={verificationMessage}
        autoRelogin={autoRelogin}
        afterLoginRoutesPath={afterLoginRoutesPath}
      />
    </>
  );
};

export default EmailVerificationView;
